import { render, staticRenderFns } from "./DirectPaymentsList.vue?vue&type=template&id=7b685d0a&"
import script from "./DirectPaymentsList.vue?vue&type=script&lang=js&"
export * from "./DirectPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b685d0a')) {
      api.createRecord('7b685d0a', component.options)
    } else {
      api.reload('7b685d0a', component.options)
    }
    module.hot.accept("./DirectPaymentsList.vue?vue&type=template&id=7b685d0a&", function () {
      api.rerender('7b685d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/directPaymentDetailPages/DirectPaymentsList.vue"
export default component.exports